import { useTranslation } from "react-i18next";
import React from "react";
import { Box, Container, Typography, Link, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        // These properties make the footer a "sticky" banner
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        // Styling for the banner
        backgroundColor: "#f5f5f5",
        color: "text.secondary",
        py: 1.5, // Make it a bit skinnier
        zIndex: (theme) => theme.zIndex.appBar - 1, // Below AppBar and Drawer
        borderTop: "1px solid #e0e0e0",
      }}
    >
      <Container maxWidth="lg">
        <Grid container justifyContent="space-between" alignItems="center">
          {/* Left Side: Logo and Copyright */}
          <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img
              src="/assets/images/eil_logo.svg"
              alt="Epi-Insight Logo"
              style={{ height: "24px" }}
            />
            <Typography variant="body2">
              © {currentYear}{" "}
              <Link
                href="https://epi-insight.com"
                target="_blank"
                rel="noopener"
                color="inherit"
                underline="hover"
              >
                Epi-Insight Limited
              </Link>
              . {t("footer.allRightsReserved")}
            </Typography>
          </Grid>

          {/* Right Side: Navigation Links */}
          <Grid item sx={{ display: "flex", gap: 2 }}>
            <Link
              component={RouterLink}
              to="/privacy"
              color="inherit"
              underline="hover"
              sx={{ fontSize: "0.8rem" }}
            >
              {t("footer.privacy")}
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
